import { useState, useEffect } from "react";
import { NotificationService } from "@/services/notification.service";
import { useCallback } from "react";

export function useInfoCards(memberId: string, notifyRefreshKey?: number) {
  const [infoCards, setInfoCards] = useState<any[]>([]);
  const [notifications, setNotifications] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchNotifications() {
      setLoading(true);
      setError(null);
      try {
        const notificationService = new NotificationService();
        const notifyRes = await notificationService.getInfoNotifications();
        setInfoCards([]); // Skip info cards API, set empty array
        setNotifications(notifyRes || []);
      } catch (err: any) {
        setError(err?.message || "Failed to fetch notifications");
      } finally {
        setLoading(false);
      }
    }
    if (memberId) fetchNotifications();
  }, [memberId, notifyRefreshKey]);

  const markNotificationAsRead = useCallback(
    async (id: string) => {
      const service = new NotificationService();
      await service.markAsRead(id);
      if (typeof notifyRefreshKey === "number") {
        // No direct setNotifyRefreshKey here, so this is for use by the caller
      }
    },
    [notifyRefreshKey]
  );

  return { infoCards, notifications, loading, error, markNotificationAsRead };
}
